<template>
  <div id="operation-record">
    <div class="ipub-h1 mar-b-24 line-h-40 relative">
      Operation Record
      <div class="ipub-p1 right-option">
        <ipub-button type="primary"
                     :loading="loading"
                     @click="exp">
          Export
        </ipub-button>
      </div>
    </div>
    <div class="ipub-filter-div mar-b-20">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="4">
            <span class="ipub-p2 fw-bd line-h-40"
                  style="display:inline-block;width:60px">Roles</span>
            <ipub-select style="width:calc(100% - 60px)"
                         v-model="roleIdListArr"
                         :clear="true"
                         mode="multiple"
                         search
                         @search="getRoles"
                         placeholder="Choose Roles"
                         @change="getList()">
              <ipub-select-option v-for="item in roles"
                                  :value="item.id"
                                  :key="item.id">
                <template v-if="item.journal&&item.journal.name">{{item.journal.name}}</template> {{item.name}}
              </ipub-select-option>
            </ipub-select>
          </ipub-col>
          <ipub-col :span="8">
            <site-search-group v-model.trim="params.keyword"
                               placeholder="Search for Operator Name, email or information"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <ipub-row :gutter="[12,16]">
            <ipub-col :span="5"
                      class="flex">
              <span class="line-h-40 nowrap ipub-p2 fw-bd">Operation Type</span>
              <ipub-select class="mar-l-10"
                           v-model="params.type"
                           :clear="true"
                           placeholder="Select Operation Type"
                           @change="getList()">
                <ipub-select-option :value="key"
                                    v-for="(item, key) in OPERATIONTYPE"
                                    :key="key">
                  {{item}}
                </ipub-select-option>
              </ipub-select>
            </ipub-col>
            <ipub-col class="flex"
                      :span="7">
              <span class="line-h-40 nowrap ipub-p2 fw-bd">Menu Type</span>
              <ipub-select class="mar-l-10"
                           v-model="params.authorityCode"
                           placeholder="Select Menu Type"
                           :tree="true"
                           :clear="true"
                           @change="getList()"
                           optionKey="code"
                           :options="MenusList" />
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="12">
            <ipub-col :span="6"
                      class="flex">
              <span class="line-h-40 nowrap ipub-p2 fw-bd">Operation Time</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width:500px"
                                      :placeholder="['From','To']"
                                      @change="(e)=>changeDate('time', e)"
                                      v-model="date" />
            </ipub-col>
            <ipub-col :span="6">
              <ipub-button type="primary"
                           :plain="cho!=='t'"
                           @click="changeDate('t', 0)">Today</ipub-button>
              <ipub-button type="primary"
                           :plain="cho!=='y'"
                           @click="changeDate('y', -1)">Yesterday</ipub-button>
              <ipub-button type="primary"
                           :plain="cho!=='7'"
                           @click="changeDate('7', -7)">Last 7 Days</ipub-button>
              <ipub-button type="primary"
                           :plain="cho!=='30'"
                           @click="changeDate('30', -30)">Last 30 Days</ipub-button>
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div>
      <ipub-table :columns="columns"
                  fixed
                  :empty="{icon:'iconmail'}"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:type="{text}">
          {{OPERATIONTYPE[text]}}
        </template>
        <template v-slot:opEmail="{ text }">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text.email||'--'}`" />
        </template>
        <template v-slot:="{}">
          {{text.email || '--'}}
        </template>
        <template v-slot:role="{ text }">
          <ipub-tooltip v-if="text&&text.length"
                        style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text.map((item)=>{return `${item.journal&&item.journal.name||''} ${item.name}`}).join(', ')}`" />
          <template v-else>- -</template>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip>
            <div slot="title">detail</div>
            <ipub-icon type="iconViewDetails"
                       @click="detail(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Detail :inputData="inputData"
            :isVisable="isVisable"
            @cancel="cancel"></Detail>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
